export const getZeroBeforeInt = Num => {
  return !Num ? '00' : Num < 100 ? ('0' + Num)?.slice(-2) : Num
}

export const getIdFormate = Num => {
  return Num ? ('0000' + Num)?.slice(-5) : '00000'
}
